module.exports = __webpack_public_path__ + "img/sisterhood-logo.00562399.svg";